export default __webpack_public_path__ + "static/media/1975.d1141863.png";